import styled, { css } from 'styled-components';

import { hexToRGB, typography } from '@/styles/helpers';

export interface ScUserSessionTimerProps {
  isMobile?: boolean;
}

export const ScUserSessionTimer = styled.div<ScUserSessionTimerProps>`
  position: ${({ isMobile }) => (isMobile ? 'relative' : 'fixed')};
  inset: auto 0 0;
  background-color: ${({ theme }) => theme.grayDarkColor};
  color: ${({ theme }) => theme.blackLightColor};
  ${typography['body2regular']}
  padding: 6px;
  display: flex;
  justify-content: center;
  z-index: 100;

  ${({ isMobile, theme }) =>
    isMobile &&
    css`
      border-top: 1px solid ${hexToRGB(theme.whiteColor, 0.2)};
    `}

  & > .timer-wrapper {
    display: flex;
    align-items: center;
    column-gap: 4px;

    & > svg path {
      fill: ${({ theme }) => theme.blackLightColor};
    }

    & > .timer {
      font-variant-numeric: tabular-nums;
    }
  }
`;
